import { render, staticRenderFns } from "./ManualRune.vue?vue&type=template&id=0c030e5f&"
import script from "./ManualRune.vue?vue&type=script&lang=js&"
export * from "./ManualRune.vue?vue&type=script&lang=js&"
import style0 from "./ManualRune.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports